import { render, staticRenderFns } from "./Globle.vue?vue&type=template&id=4f57314d"
import script from "./Globle.vue?vue&type=script&lang=js"
export * from "./Globle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports